import { Link } from "react-router-dom";
import { Check, X, Flag } from "lucide-react";

/* One cell of the "What's missing" list: a tick, a gap you can tap to fix, n/a, or a person's mark. */
export const GapCell = ({ cell, testid, onMark }) => {
  if (cell.state === "done") {
    return <span data-testid={testid} title={cell.words} className="inline-flex text-emerald-600"><Check className="w-5 h-5" strokeWidth={3} /></span>;
  }
  if (cell.state === "na") {
    return <span data-testid={testid} title={cell.words} className="text-[11px] font-semibold text-slate-400">n/a</span>;
  }
  if (cell.state === "marked") {
    return (
      <button data-testid={testid} onClick={onMark} title={cell.words}
        className="inline-flex items-center gap-1 text-[11px] font-bold text-slate-600 bg-slate-100 border border-slate-300 rounded px-1.5 py-1 hover:border-[#B01E28] transition-colors">
        <Flag className="w-3 h-3" />marked
      </button>
    );
  }
  return (
    <div className="flex flex-col items-start gap-1">
      <Link data-testid={testid} to={cell.link || "#"} title={cell.detail || cell.words} onClick={() => window.scrollTo(0, 0)}
        className="inline-flex items-start gap-1 text-[11px] leading-tight font-semibold text-[#B01E28] bg-red-50 border border-red-200 rounded px-1.5 py-1 hover:bg-red-100 transition-colors">
        <X className="w-3.5 h-3.5 shrink-0" strokeWidth={3} /><span>{cell.words}</span>
      </Link>
      {cell.can_mark && (
        <button data-testid={`${testid}-mark`} onClick={onMark}
          className="whitespace-nowrap text-[10px] font-bold text-slate-500 hover:text-[#B01E28] underline underline-offset-2">
          Mark with a reason
        </button>
      )}
    </div>
  );
};
